import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import localizationService from "../../services/localization-service.js";
import { closeVerificationModal } from "../../actions/portal.action";

const VerificationPromptModal = ({ isOpen }) => {
  const selectedlang = useSelector((state) => state.account.lang);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleVerifyNow = () => {
    dispatch(closeVerificationModal());
    navigate("/verification");
  };

  const handleLater = () => {
    dispatch(closeVerificationModal());
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div
          className="px-6 py-4 border-b border-gray-200"
          style={{ position: "relative" }}
        >
          <h3 className="text-lg font-medium text-gray-900">
            {localizationService.getLocalizationValue(
              "verificationModalTitle",
              selectedlang,
            )}
          </h3>
        </div>
        <div className="px-6 py-4">
          <p className="text-sm text-gray-500">
            {localizationService.getLocalizationValue(
              "verificationModalBody",
              selectedlang,
            )}
          </p>
        </div>
        <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center space-x-3">
          <button
            onClick={handleVerifyNow}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#9aa82d] hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            {localizationService.getLocalizationValue(
              "verifyNow",
              selectedlang,
            )}
          </button>
          <button
            onClick={handleLater}
            className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-[#ffffff] hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200"
          >
            {localizationService.getLocalizationValue("later", selectedlang)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationPromptModal;
